import React from 'react';
import { Box } from '@qga/roo-ui/components';

import { SUPPORT_HOURS } from '@/components/ContactUs';
import Divider from '@/components/Divider';
import LinkButton from '@/components/LinkButton';
import useScrollIntoView from '@/hooks/useScrollIntoView';
import CallUs from '../CallUs';
import Items from '../Items';
import mail from './assets/mail.svg';
import support from './assets/support.svg';

const Support = React.memo(() => {
  const scrollToForm = useScrollIntoView('#contact-us-form');

  return (
    <Box mb="16">
      <Box mb="4" fontSize="xl">
        Qantas Holidays Support
      </Box>
      <Divider mb="10" />
      <Box mb="4" fontSize="lg">
        Operating hours
      </Box>
      <Box>
        <Box>
          Need to change, cancel or enquire about your booking. Our customer
          service team is available from
        </Box>
        <Box fontWeight="bold">{` ${SUPPORT_HOURS}.`}</Box>
      </Box>
      <Items
        items={[
          {
            key: 'CALL_US',
            icon: support,
            title: 'Call us',
            description: `
          We strongly encourage only those customers staying
          within the next 7 days to call us if needed.
        `,
            label: 'Support',
            cta: <CallUs />,
          },
          {
            key: 'EMAIL_US',
            icon: mail,
            title: 'Email us',
            description: `
          Use our contact form to get in touch with our team if you have 
          questions about your booking, 
          make changes, or give feedback about your experience and more.
        `,
            label: 'Contact form',
            cta: (
              <LinkButton onClick={scrollToForm}>
                Email us via our contact form
              </LinkButton>
            ),
          },
        ]}
      />
    </Box>
  );
});

export default Support;
